import {
  Funnel,
  FunnelChart as RechartsFunnelChart,
  LabelList,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

type FunnelDatum = {
  stage: string;
  dossiers: number;
};

type FunnelChartProps = {
  data: FunnelDatum[];
};

const formatTooltipValue = (value: string | number) => [`${value} dossiers`, "Volume"];

export default function FunnelChart({ data }: FunnelChartProps) {
  return (
    <div className="h-[320px] w-full" data-testid="funnel-chart">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsFunnelChart>
          <Tooltip formatter={formatTooltipValue} />
          <Funnel dataKey="dossiers" data={data} isAnimationActive fill="#C9A84C">
            <LabelList position="right" dataKey="stage" stroke="#0D1B2A" fill="#0D1B2A" />
          </Funnel>
        </RechartsFunnelChart>
      </ResponsiveContainer>
    </div>
  );
}
